const expirySuffix = 'Exp';
export const getCache = (key: string) => {
   if (!key)
      return null;

   if (IsExpired(key)) {
      return null;
   }

   return JSON.parse(localStorage.getItem(key) ?? '{}');
}

export const setCache = (key: string, data: string, expirySeconds: number): void => {
   if (!key || !data || !expirySeconds)
      return;

   localStorage.setItem(key, data);
   localStorage.setItem(key + expirySuffix, (Date.now() + expirySeconds * 1000).toString());
}

export function IsExpired(key: string) {
   return (localStorage.getItem(key) && localStorage.getItem(key + expirySuffix))
      ? +(localStorage.getItem(key + expirySuffix) ?? 0) < Date.now()
      : true;
}

export function SetExpiry(key: string, time: any) {
   localStorage.setItem(key + 'Exp', Date.now() + time);
}